export const iconMap = {
"AccessAlarms": () => import("@spoctech/icons/AccessAlarms"),
"AccountCircle": () => import("@spoctech/icons/AccountCircle"),
"AccountCircleOutlined": () => import("@spoctech/icons/AccountCircleOutlined"),
"AccountCircleRounded": () => import("@spoctech/icons/AccountCircleRounded"),
"Ad": () => import("@spoctech/icons/Ad"),
"AddTaskOutlined": () => import("@spoctech/icons/AddTaskOutlined"),
"AddressIcon": () => import("@spoctech/icons/AddressIcon"),
"Ae": () => import("@spoctech/icons/Ae"),
"Af": () => import("@spoctech/icons/Af"),
"AfternoonIcon": () => import("@spoctech/icons/AfternoonIcon"),
"Ag": () => import("@spoctech/icons/Ag"),
"AgileAndScrumIcon": () => import("@spoctech/icons/AgileAndScrumIcon"),
"Ai": () => import("@spoctech/icons/Ai"),
"AiAndMlIcon": () => import("@spoctech/icons/AiAndMlIcon"),
"Al": () => import("@spoctech/icons/Al"),
"AllCoursesIcon": () => import("@spoctech/icons/AllCoursesIcon"),
"Am": () => import("@spoctech/icons/Am"),
"AmazonPay": () => import("@spoctech/icons/AmazonPay"),
"AmericanExpress": () => import("@spoctech/icons/AmericanExpress"),
"Ao": () => import("@spoctech/icons/Ao"),
"Aq": () => import("@spoctech/icons/Aq"),
"Ar": () => import("@spoctech/icons/Ar"),
"Arab": () => import("@spoctech/icons/Arab"),
"ArrowNarrowRightIcon": () => import("@spoctech/icons/ArrowNarrowRightIcon"),
"ArrowRedo": () => import("@spoctech/icons/ArrowRedo"),
"ArrowUpGraph": () => import("@spoctech/icons/ArrowUpGraph"),
"ArrowsRightLeft": () => import("@spoctech/icons/ArrowsRightLeft"),
"ArrowsUpDown": () => import("@spoctech/icons/ArrowsUpDown"),
"As": () => import("@spoctech/icons/As"),
"Asean": () => import("@spoctech/icons/Asean"),
"AssignmentLateOutlined": () => import("@spoctech/icons/AssignmentLateOutlined"),
"AssignmentOutlined": () => import("@spoctech/icons/AssignmentOutlined"),
"AssignmentReturnOutlined": () => import("@spoctech/icons/AssignmentReturnOutlined"),
"AssignmentReturnedOutlined": () => import("@spoctech/icons/AssignmentReturnedOutlined"),
"AssignmentThin": () => import("@spoctech/icons/AssignmentThin"),
"AssignmentTurnedInOutlined": () => import("@spoctech/icons/AssignmentTurnedInOutlined"),
"At": () => import("@spoctech/icons/At"),
"AttachmentIcon": () => import("@spoctech/icons/AttachmentIcon"),
"Au": () => import("@spoctech/icons/Au"),
"AutomobileIcon": () => import("@spoctech/icons/AutomobileIcon"),
"Aw": () => import("@spoctech/icons/Aw"),
"AwardOutlined": () => import("@spoctech/icons/AwardOutlined"),
"Ax": () => import("@spoctech/icons/Ax"),
"Az": () => import("@spoctech/icons/Az"),
"Ba": () => import("@spoctech/icons/Ba"),
"BankIcon": () => import("@spoctech/icons/BankIcon"),
"Bb": () => import("@spoctech/icons/Bb"),
"Bd": () => import("@spoctech/icons/Bd"),
"Be": () => import("@spoctech/icons/Be"),
"Bf": () => import("@spoctech/icons/Bf"),
"Bg": () => import("@spoctech/icons/Bg"),
"Bh": () => import("@spoctech/icons/Bh"),
"Bi": () => import("@spoctech/icons/Bi"),
"Bj": () => import("@spoctech/icons/Bj"),
"Bl": () => import("@spoctech/icons/Bl"),
"BlogsIcon": () => import("@spoctech/icons/BlogsIcon"),
"Bm": () => import("@spoctech/icons/Bm"),
"Bn": () => import("@spoctech/icons/Bn"),
"Bo": () => import("@spoctech/icons/Bo"),
"Bq": () => import("@spoctech/icons/Bq"),
"Br": () => import("@spoctech/icons/Br"),
"BriefcaseThin": () => import("@spoctech/icons/BriefcaseThin"),
"Bs": () => import("@spoctech/icons/Bs"),
"Bt": () => import("@spoctech/icons/Bt"),
"BuildingThin": () => import("@spoctech/icons/BuildingThin"),
"BulbOutlined": () => import("@spoctech/icons/BulbOutlined"),
"Bv": () => import("@spoctech/icons/Bv"),
"Bw": () => import("@spoctech/icons/Bw"),
"By": () => import("@spoctech/icons/By"),
"Bz": () => import("@spoctech/icons/Bz"),
"Ca": () => import("@spoctech/icons/Ca"),
"CalendarIcon": () => import("@spoctech/icons/CalendarIcon"),
"CalendarOutlined": () => import("@spoctech/icons/CalendarOutlined"),
"CallBackIcon": () => import("@spoctech/icons/CallBackIcon"),
"CallOutlined": () => import("@spoctech/icons/CallOutlined"),
"CancelOutlined": () => import("@spoctech/icons/CancelOutlined"),
"CareerPrepAndCapstoneProjectIcon": () => import("@spoctech/icons/CareerPrepAndCapstoneProjectIcon"),
"CartIcon": () => import("@spoctech/icons/CartIcon"),
"CaseStudyIcon": () => import("@spoctech/icons/CaseStudyIcon"),
"Cc": () => import("@spoctech/icons/Cc"),
"Cd": () => import("@spoctech/icons/Cd"),
"Cefta": () => import("@spoctech/icons/Cefta"),
"Cf": () => import("@spoctech/icons/Cf"),
"Cg": () => import("@spoctech/icons/Cg"),
"Ch": () => import("@spoctech/icons/Ch"),
"CheckCircleIcon": () => import("@spoctech/icons/CheckCircleIcon"),
"CheckSquare": () => import("@spoctech/icons/CheckSquare"),
"ChevronBackOutline": () => import("@spoctech/icons/ChevronBackOutline"),
"ChevronDownIcon": () => import("@spoctech/icons/ChevronDownIcon"),
"ChevronDownOutline": () => import("@spoctech/icons/ChevronDownOutline"),
"ChevronForwardOutline": () => import("@spoctech/icons/ChevronForwardOutline"),
"ChevronLeftIcon": () => import("@spoctech/icons/ChevronLeftIcon"),
"ChevronLeftOutline": () => import("@spoctech/icons/ChevronLeftOutline"),
"ChevronRightIcon": () => import("@spoctech/icons/ChevronRightIcon"),
"ChevronRightOutline": () => import("@spoctech/icons/ChevronRightOutline"),
"ChevronUpOutline": () => import("@spoctech/icons/ChevronUpOutline"),
"Ci": () => import("@spoctech/icons/Ci"),
"Ck": () => import("@spoctech/icons/Ck"),
"Cl": () => import("@spoctech/icons/Cl"),
"CloseIcon": () => import("@spoctech/icons/CloseIcon"),
"Cm": () => import("@spoctech/icons/Cm"),
"Cn": () => import("@spoctech/icons/Cn"),
"Co": () => import("@spoctech/icons/Co"),
"CollaborationIcon": () => import("@spoctech/icons/CollaborationIcon"),
"CommandButton": () => import("@spoctech/icons/CommandButton"),
"CommandKeyOutlined": () => import("@spoctech/icons/CommandKeyOutlined"),
"CompetitiveIcon": () => import("@spoctech/icons/CompetitiveIcon"),
"ComplexJourneyIcon": () => import("@spoctech/icons/ComplexJourneyIcon"),
"ComplianceIcon": () => import("@spoctech/icons/ComplianceIcon"),
"ContinuousSupportIcon": () => import("@spoctech/icons/ContinuousSupportIcon"),
"CorporateAvailabilityIcon": () => import("@spoctech/icons/CorporateAvailabilityIcon"),
"CorporateGroupTrainingIcon": () => import("@spoctech/icons/CorporateGroupTrainingIcon"),
"CorporateTrainingIcon": () => import("@spoctech/icons/CorporateTrainingIcon"),
"CourseCompletionCertificate": () => import("@spoctech/icons/CourseCompletionCertificate"),
"CourseTypeIcon": () => import("@spoctech/icons/CourseTypeIcon"),
"Cp": () => import("@spoctech/icons/Cp"),
"Cr": () => import("@spoctech/icons/Cr"),
"CreditCardIcon": () => import("@spoctech/icons/CreditCardIcon"),
"Cu": () => import("@spoctech/icons/Cu"),
"CulturalTransformationIcon": () => import("@spoctech/icons/CulturalTransformationIcon"),
"CustomerSatisfactionIcon": () => import("@spoctech/icons/CustomerSatisfactionIcon"),
"Cv": () => import("@spoctech/icons/Cv"),
"Cw": () => import("@spoctech/icons/Cw"),
"Cx": () => import("@spoctech/icons/Cx"),
"Cy": () => import("@spoctech/icons/Cy"),
"Cz": () => import("@spoctech/icons/Cz"),
"DataAnalyticsIcon": () => import("@spoctech/icons/DataAnalyticsIcon"),
"DataOverloadIcon": () => import("@spoctech/icons/DataOverloadIcon"),
"DataWranglingIcon": () => import("@spoctech/icons/DataWranglingIcon"),
"De": () => import("@spoctech/icons/De"),
"DescriptionOutlined": () => import("@spoctech/icons/DescriptionOutlined"),
"DevOpsIcon": () => import("@spoctech/icons/DevOpsIcon"),
"DevToolOutlined": () => import("@spoctech/icons/DevToolOutlined"),
"Dg": () => import("@spoctech/icons/Dg"),
"DiamondIcon": () => import("@spoctech/icons/DiamondIcon"),
"DigitalMarketingIcon": () => import("@spoctech/icons/DigitalMarketingIcon"),
"DigitalTransformationIcon": () => import("@spoctech/icons/DigitalTransformationIcon"),
"DiscoverNetwork": () => import("@spoctech/icons/DiscoverNetwork"),
"DiskOutlined": () => import("@spoctech/icons/DiskOutlined"),
"Dj": () => import("@spoctech/icons/Dj"),
"Dk": () => import("@spoctech/icons/Dk"),
"Dm": () => import("@spoctech/icons/Dm"),
"Do": () => import("@spoctech/icons/Do"),
"DraftSharp": () => import("@spoctech/icons/DraftSharp"),
"DurationIcon": () => import("@spoctech/icons/DurationIcon"),
"DynamicFeedOutlined": () => import("@spoctech/icons/DynamicFeedOutlined"),
"Dz": () => import("@spoctech/icons/Dz"),
"Eac": () => import("@spoctech/icons/Eac"),
"Ec": () => import("@spoctech/icons/Ec"),
"EditIcon": () => import("@spoctech/icons/EditIcon"),
"EducationIcon": () => import("@spoctech/icons/EducationIcon"),
"Ee": () => import("@spoctech/icons/Ee"),
"Eg": () => import("@spoctech/icons/Eg"),
"Eh": () => import("@spoctech/icons/Eh"),
"ElevateTrainingProgram": () => import("@spoctech/icons/ElevateTrainingProgram"),
"EmailOutlined": () => import("@spoctech/icons/EmailOutlined"),
"Er": () => import("@spoctech/icons/Er"),
"Es": () => import("@spoctech/icons/Es"),
"EsCt": () => import("@spoctech/icons/EsCt"),
"EsGa": () => import("@spoctech/icons/EsGa"),
"EsPv": () => import("@spoctech/icons/EsPv"),
"Et": () => import("@spoctech/icons/Et"),
"EthicalIcon": () => import("@spoctech/icons/EthicalIcon"),
"Eu": () => import("@spoctech/icons/Eu"),
"EveningIcon": () => import("@spoctech/icons/EveningIcon"),
"EventSeat": () => import("@spoctech/icons/EventSeat"),
"EventSeatOutlined": () => import("@spoctech/icons/EventSeatOutlined"),
"EventSeatRounded": () => import("@spoctech/icons/EventSeatRounded"),
"EventsAndWebinarsIcon": () => import("@spoctech/icons/EventsAndWebinarsIcon"),
"EverEvolvingIcon": () => import("@spoctech/icons/EverEvolvingIcon"),
"ExcellenceIcon": () => import("@spoctech/icons/ExcellenceIcon"),
"ExploratoryDataAnalysis": () => import("@spoctech/icons/ExploratoryDataAnalysis"),
"EyeOutline": () => import("@spoctech/icons/EyeOutline"),
"FacebookFill": () => import("@spoctech/icons/FacebookFill"),
"FacebookIcon": () => import("@spoctech/icons/FacebookIcon"),
"FacebookOutlined": () => import("@spoctech/icons/FacebookOutlined"),
"FacebookSolid": () => import("@spoctech/icons/FacebookSolid"),
"FeedOutlined": () => import("@spoctech/icons/FeedOutlined"),
"FeedbackOutlined": () => import("@spoctech/icons/FeedbackOutlined"),
"Fi": () => import("@spoctech/icons/Fi"),
"FilterIcon": () => import("@spoctech/icons/FilterIcon"),
"FinanceAndBankingIcon": () => import("@spoctech/icons/FinanceAndBankingIcon"),
"Fj": () => import("@spoctech/icons/Fj"),
"Fk": () => import("@spoctech/icons/Fk"),
"Flash6737345": () => import("@spoctech/icons/Flash6737345"),
"Fm": () => import("@spoctech/icons/Fm"),
"Fo": () => import("@spoctech/icons/Fo"),
"Fr": () => import("@spoctech/icons/Fr"),
"GTranslateOutlined": () => import("@spoctech/icons/GTranslateOutlined"),
"Ga": () => import("@spoctech/icons/Ga"),
"Gb": () => import("@spoctech/icons/Gb"),
"GbEng": () => import("@spoctech/icons/GbEng"),
"GbNir": () => import("@spoctech/icons/GbNir"),
"GbSct": () => import("@spoctech/icons/GbSct"),
"GbWls": () => import("@spoctech/icons/GbWls"),
"Gd": () => import("@spoctech/icons/Gd"),
"Ge": () => import("@spoctech/icons/Ge"),
"GenderIcon": () => import("@spoctech/icons/GenderIcon"),
"Gf": () => import("@spoctech/icons/Gf"),
"Gg": () => import("@spoctech/icons/Gg"),
"Gh": () => import("@spoctech/icons/Gh"),
"Gi": () => import("@spoctech/icons/Gi"),
"Gl": () => import("@spoctech/icons/Gl"),
"Gm": () => import("@spoctech/icons/Gm"),
"Gn": () => import("@spoctech/icons/Gn"),
"GovernmentIcon": () => import("@spoctech/icons/GovernmentIcon"),
"GovernmentThinIcon": () => import("@spoctech/icons/GovernmentThinIcon"),
"Gp": () => import("@spoctech/icons/Gp"),
"Gq": () => import("@spoctech/icons/Gq"),
"Gr": () => import("@spoctech/icons/Gr"),
"GraduationCapLight": () => import("@spoctech/icons/GraduationCapLight"),
"Group3Fill": () => import("@spoctech/icons/Group3Fill"),
"GroupOutline": () => import("@spoctech/icons/GroupOutline"),
"GroupOutlined": () => import("@spoctech/icons/GroupOutlined"),
"GroupPresentation": () => import("@spoctech/icons/GroupPresentation"),
"Groups2Outlined": () => import("@spoctech/icons/Groups2Outlined"),
"GroupsOutlined": () => import("@spoctech/icons/GroupsOutlined"),
"Gs": () => import("@spoctech/icons/Gs"),
"Gt": () => import("@spoctech/icons/Gt"),
"Gu": () => import("@spoctech/icons/Gu"),
"Gw": () => import("@spoctech/icons/Gw"),
"Gy": () => import("@spoctech/icons/Gy"),
"HealthcareIcon": () => import("@spoctech/icons/HealthcareIcon"),
"HistoryIcon": () => import("@spoctech/icons/HistoryIcon"),
"HistorySharp": () => import("@spoctech/icons/HistorySharp"),
"Hk": () => import("@spoctech/icons/Hk"),
"Hm": () => import("@spoctech/icons/Hm"),
"Hn": () => import("@spoctech/icons/Hn"),
"HomeIcon": () => import("@spoctech/icons/HomeIcon"),
"Hr": () => import("@spoctech/icons/Hr"),
"Ht": () => import("@spoctech/icons/Ht"),
"Hu": () => import("@spoctech/icons/Hu"),
"Ic": () => import("@spoctech/icons/Ic"),
"Id": () => import("@spoctech/icons/Id"),
"Ie": () => import("@spoctech/icons/Ie"),
"Il": () => import("@spoctech/icons/Il"),
"Im": () => import("@spoctech/icons/Im"),
"ImprovementOutline": () => import("@spoctech/icons/ImprovementOutline"),
"In": () => import("@spoctech/icons/In"),
"InfoIcon": () => import("@spoctech/icons/InfoIcon"),
"InovationIcon": () => import("@spoctech/icons/InovationIcon"),
"InsightfulAnalyticsIcon": () => import("@spoctech/icons/InsightfulAnalyticsIcon"),
"InstagramOutlined": () => import("@spoctech/icons/InstagramOutlined"),
"InstagrapIcon": () => import("@spoctech/icons/InstagrapIcon"),
"IntegrationIcon": () => import("@spoctech/icons/IntegrationIcon"),
"IntegrityIcon": () => import("@spoctech/icons/IntegrityIcon"),
"IntroductionDataAnalyticsIcon": () => import("@spoctech/icons/IntroductionDataAnalyticsIcon"),
"InventorySharp": () => import("@spoctech/icons/InventorySharp"),
"Io": () => import("@spoctech/icons/Io"),
"Iq": () => import("@spoctech/icons/Iq"),
"Ir": () => import("@spoctech/icons/Ir"),
"Is": () => import("@spoctech/icons/Is"),
"It": () => import("@spoctech/icons/It"),
"ItSecurityIcon": () => import("@spoctech/icons/ItSecurityIcon"),
"ItServiceManagementIcon": () => import("@spoctech/icons/ItServiceManagementIcon"),
"Je": () => import("@spoctech/icons/Je"),
"Jm": () => import("@spoctech/icons/Jm"),
"Jo": () => import("@spoctech/icons/Jo"),
"Jp": () => import("@spoctech/icons/Jp"),
"Ke": () => import("@spoctech/icons/Ke"),
"Kg": () => import("@spoctech/icons/Kg"),
"Kh": () => import("@spoctech/icons/Kh"),
"Ki": () => import("@spoctech/icons/Ki"),
"Km": () => import("@spoctech/icons/Km"),
"Kn": () => import("@spoctech/icons/Kn"),
"Kp": () => import("@spoctech/icons/Kp"),
"Kr": () => import("@spoctech/icons/Kr"),
"Kw": () => import("@spoctech/icons/Kw"),
"Ky": () => import("@spoctech/icons/Ky"),
"Kz": () => import("@spoctech/icons/Kz"),
"La": () => import("@spoctech/icons/La"),
"LanguageIcon": () => import("@spoctech/icons/LanguageIcon"),
"LanguageOutlined": () => import("@spoctech/icons/LanguageOutlined"),
"LaptopWindowsOutlined": () => import("@spoctech/icons/LaptopWindowsOutlined"),
"LaptopWindowsRounded": () => import("@spoctech/icons/LaptopWindowsRounded"),
"LaptopWindowsSharp": () => import("@spoctech/icons/LaptopWindowsSharp"),
"Lb": () => import("@spoctech/icons/Lb"),
"Lc": () => import("@spoctech/icons/Lc"),
"LeadershipIcon": () => import("@spoctech/icons/LeadershipIcon"),
"Li": () => import("@spoctech/icons/Li"),
"LightBulbIcon": () => import("@spoctech/icons/LightBulbIcon"),
"LinkedinIcon": () => import("@spoctech/icons/LinkedinIcon"),
"LinkedinOutlined": () => import("@spoctech/icons/LinkedinOutlined"),
"LinkedinSolid": () => import("@spoctech/icons/LinkedinSolid"),
"ListToDoOutlined": () => import("@spoctech/icons/ListToDoOutlined"),
"Lk": () => import("@spoctech/icons/Lk"),
"LocationIcon": () => import("@spoctech/icons/LocationIcon"),
"LocationOnOutlined": () => import("@spoctech/icons/LocationOnOutlined"),
"LogoutIcon": () => import("@spoctech/icons/LogoutIcon"),
"Lr": () => import("@spoctech/icons/Lr"),
"Ls": () => import("@spoctech/icons/Ls"),
"Lt": () => import("@spoctech/icons/Lt"),
"Lu": () => import("@spoctech/icons/Lu"),
"Lv": () => import("@spoctech/icons/Lv"),
"Ly": () => import("@spoctech/icons/Ly"),
"Ma": () => import("@spoctech/icons/Ma"),
"Maestro": () => import("@spoctech/icons/Maestro"),
"MailIcon": () => import("@spoctech/icons/MailIcon"),
"ManufacturingIcon": () => import("@spoctech/icons/ManufacturingIcon"),
"MarketChangesIcon": () => import("@spoctech/icons/MarketChangesIcon"),
"MasterCard": () => import("@spoctech/icons/MasterCard"),
"Mc": () => import("@spoctech/icons/Mc"),
"McqIcon": () => import("@spoctech/icons/McqIcon"),
"Md": () => import("@spoctech/icons/Md"),
"Me": () => import("@spoctech/icons/Me"),
"Mf": () => import("@spoctech/icons/Mf"),
"Mg": () => import("@spoctech/icons/Mg"),
"Mh": () => import("@spoctech/icons/Mh"),
"MicrophoneIcon": () => import("@spoctech/icons/MicrophoneIcon"),
"MicrosoftCoursesIcon": () => import("@spoctech/icons/MicrosoftCoursesIcon"),
"MinusCircleIcon": () => import("@spoctech/icons/MinusCircleIcon"),
"MinusIcon": () => import("@spoctech/icons/MinusIcon"),
"MissionIcon": () => import("@spoctech/icons/MissionIcon"),
"Mk": () => import("@spoctech/icons/Mk"),
"Ml": () => import("@spoctech/icons/Ml"),
"Mm": () => import("@spoctech/icons/Mm"),
"Mn": () => import("@spoctech/icons/Mn"),
"Mo": () => import("@spoctech/icons/Mo"),
"MoreIcon": () => import("@spoctech/icons/MoreIcon"),
"MorningIcon": () => import("@spoctech/icons/MorningIcon"),
"Mp": () => import("@spoctech/icons/Mp"),
"Mq": () => import("@spoctech/icons/Mq"),
"Mr": () => import("@spoctech/icons/Mr"),
"Ms": () => import("@spoctech/icons/Ms"),
"Mt": () => import("@spoctech/icons/Mt"),
"Mu": () => import("@spoctech/icons/Mu"),
"MultipleQuestionsOutlined": () => import("@spoctech/icons/MultipleQuestionsOutlined"),
"Mv": () => import("@spoctech/icons/Mv"),
"Mw": () => import("@spoctech/icons/Mw"),
"Mx": () => import("@spoctech/icons/Mx"),
"My": () => import("@spoctech/icons/My"),
"Mz": () => import("@spoctech/icons/Mz"),
"Na": () => import("@spoctech/icons/Na"),
"Nc": () => import("@spoctech/icons/Nc"),
"Ne": () => import("@spoctech/icons/Ne"),
"Nf": () => import("@spoctech/icons/Nf"),
"Ng": () => import("@spoctech/icons/Ng"),
"Ni": () => import("@spoctech/icons/Ni"),
"Nl": () => import("@spoctech/icons/Nl"),
"No": () => import("@spoctech/icons/No"),
"NodesOutlined": () => import("@spoctech/icons/NodesOutlined"),
"Np": () => import("@spoctech/icons/Np"),
"Nr": () => import("@spoctech/icons/Nr"),
"Nu": () => import("@spoctech/icons/Nu"),
"Nz": () => import("@spoctech/icons/Nz"),
"ObjectivePlan": () => import("@spoctech/icons/ObjectivePlan"),
"Om": () => import("@spoctech/icons/Om"),
"OnlineTraining": () => import("@spoctech/icons/OnlineTraining"),
"OnlineTrainingOutlined": () => import("@spoctech/icons/OnlineTrainingOutlined"),
"OurMissionSolid": () => import("@spoctech/icons/OurMissionSolid"),
"Pa": () => import("@spoctech/icons/Pa"),
"PasswordIcon": () => import("@spoctech/icons/PasswordIcon"),
"Paypal": () => import("@spoctech/icons/Paypal"),
"Payu": () => import("@spoctech/icons/Payu"),
"Pc": () => import("@spoctech/icons/Pc"),
"Pe": () => import("@spoctech/icons/Pe"),
"PersonalizedIcon": () => import("@spoctech/icons/PersonalizedIcon"),
"Pf": () => import("@spoctech/icons/Pf"),
"Pg": () => import("@spoctech/icons/Pg"),
"Ph": () => import("@spoctech/icons/Ph"),
"PhoneCallbackOutlined": () => import("@spoctech/icons/PhoneCallbackOutlined"),
"PhoneIcon": () => import("@spoctech/icons/PhoneIcon"),
"Pk": () => import("@spoctech/icons/Pk"),
"Pl": () => import("@spoctech/icons/Pl"),
"PlayIcon": () => import("@spoctech/icons/PlayIcon"),
"PlusCircleIcon": () => import("@spoctech/icons/PlusCircleIcon"),
"PlusIcon": () => import("@spoctech/icons/PlusIcon"),
"Pm": () => import("@spoctech/icons/Pm"),
"Pn": () => import("@spoctech/icons/Pn"),
"Pr": () => import("@spoctech/icons/Pr"),
"PracticeTestsIcon": () => import("@spoctech/icons/PracticeTestsIcon"),
"PresentationBoard": () => import("@spoctech/icons/PresentationBoard"),
"ProfileIcon": () => import("@spoctech/icons/ProfileIcon"),
"ProjectManagementIcon": () => import("@spoctech/icons/ProjectManagementIcon"),
"ProvenResultIcon": () => import("@spoctech/icons/ProvenResultIcon"),
"Ps": () => import("@spoctech/icons/Ps"),
"Pt": () => import("@spoctech/icons/Pt"),
"Pw": () => import("@spoctech/icons/Pw"),
"Py": () => import("@spoctech/icons/Py"),
"Qa": () => import("@spoctech/icons/Qa"),
"QualityManagementIcon": () => import("@spoctech/icons/QualityManagementIcon"),
"QuestionIcon": () => import("@spoctech/icons/QuestionIcon"),
"RapidlyExpandingCommunitySolid": () => import("@spoctech/icons/RapidlyExpandingCommunitySolid"),
"Razorpay": () => import("@spoctech/icons/Razorpay"),
"Re": () => import("@spoctech/icons/Re"),
"ReferralIcon": () => import("@spoctech/icons/ReferralIcon"),
"ResourcesIcon": () => import("@spoctech/icons/ResourcesIcon"),
"RestimonialsIcon": () => import("@spoctech/icons/RestimonialsIcon"),
"RetailIcon": () => import("@spoctech/icons/RetailIcon"),
"RiskMitigationIcon": () => import("@spoctech/icons/RiskMitigationIcon"),
"Ro": () => import("@spoctech/icons/Ro"),
"Rs": () => import("@spoctech/icons/Rs"),
"RssFeedOutlined": () => import("@spoctech/icons/RssFeedOutlined"),
"Ru": () => import("@spoctech/icons/Ru"),
"Rupay": () => import("@spoctech/icons/Rupay"),
"Rw": () => import("@spoctech/icons/Rw"),
"Sa": () => import("@spoctech/icons/Sa"),
"SalaryOutline": () => import("@spoctech/icons/SalaryOutline"),
"Sb": () => import("@spoctech/icons/Sb"),
"Sc": () => import("@spoctech/icons/Sc"),
"ScalabilityIcon": () => import("@spoctech/icons/ScalabilityIcon"),
"ScheduleOutlined": () => import("@spoctech/icons/ScheduleOutlined"),
"ScheduleRounded": () => import("@spoctech/icons/ScheduleRounded"),
"ScheduleSharp": () => import("@spoctech/icons/ScheduleSharp"),
"Sd": () => import("@spoctech/icons/Sd"),
"Se": () => import("@spoctech/icons/Se"),
"SearchIcon": () => import("@spoctech/icons/SearchIcon"),
"SearchOutlined": () => import("@spoctech/icons/SearchOutlined"),
"SeatsAvailableIcon": () => import("@spoctech/icons/SeatsAvailableIcon"),
"SecurityIcon": () => import("@spoctech/icons/SecurityIcon"),
"SendIcon": () => import("@spoctech/icons/SendIcon"),
"Sg": () => import("@spoctech/icons/Sg"),
"Sh": () => import("@spoctech/icons/Sh"),
"ShAc": () => import("@spoctech/icons/ShAc"),
"ShHl": () => import("@spoctech/icons/ShHl"),
"ShTa": () => import("@spoctech/icons/ShTa"),
"ShareIcon": () => import("@spoctech/icons/ShareIcon"),
"ShoppingCartOutlined": () => import("@spoctech/icons/ShoppingCartOutlined"),
"Si": () => import("@spoctech/icons/Si"),
"Sj": () => import("@spoctech/icons/Sj"),
"Sk": () => import("@spoctech/icons/Sk"),
"Sl": () => import("@spoctech/icons/Sl"),
"Sm": () => import("@spoctech/icons/Sm"),
"Sn": () => import("@spoctech/icons/Sn"),
"So": () => import("@spoctech/icons/So"),
"SoftwareDevelopmentIcon": () => import("@spoctech/icons/SoftwareDevelopmentIcon"),
"SpeakerOutlined": () => import("@spoctech/icons/SpeakerOutlined"),
"SqlAndNosqlDatabasesIcon": () => import("@spoctech/icons/SqlAndNosqlDatabasesIcon"),
"SquarePenOutlined": () => import("@spoctech/icons/SquarePenOutlined"),
"Sr": () => import("@spoctech/icons/Sr"),
"Ss": () => import("@spoctech/icons/Ss"),
"St": () => import("@spoctech/icons/St"),
"StarIcon": () => import("@spoctech/icons/StarIcon"),
"StarRounded": () => import("@spoctech/icons/StarRounded"),
"Stripe": () => import("@spoctech/icons/Stripe"),
"SunOutlined": () => import("@spoctech/icons/SunOutlined"),
"SunRaiseOutline": () => import("@spoctech/icons/SunRaiseOutline"),
"SunSetOutlined": () => import("@spoctech/icons/SunSetOutlined"),
"SupplyChainIcon": () => import("@spoctech/icons/SupplyChainIcon"),
"Sv": () => import("@spoctech/icons/Sv"),
"Sx": () => import("@spoctech/icons/Sx"),
"Sy": () => import("@spoctech/icons/Sy"),
"Sz": () => import("@spoctech/icons/Sz"),
"TaskAltOutlined": () => import("@spoctech/icons/TaskAltOutlined"),
"TaskOutlined": () => import("@spoctech/icons/TaskOutlined"),
"Tc": () => import("@spoctech/icons/Tc"),
"Td": () => import("@spoctech/icons/Td"),
"Tf": () => import("@spoctech/icons/Tf"),
"Tg": () => import("@spoctech/icons/Tg"),
"Th": () => import("@spoctech/icons/Th"),
"ThumbUpOutlined": () => import("@spoctech/icons/ThumbUpOutlined"),
"ThumbUpSharp": () => import("@spoctech/icons/ThumbUpSharp"),
"TimeIcon": () => import("@spoctech/icons/TimeIcon"),
"TimeRemainingIcon": () => import("@spoctech/icons/TimeRemainingIcon"),
"Tj": () => import("@spoctech/icons/Tj"),
"Tk": () => import("@spoctech/icons/Tk"),
"Tl": () => import("@spoctech/icons/Tl"),
"Tm": () => import("@spoctech/icons/Tm"),
"Tn": () => import("@spoctech/icons/Tn"),
"To": () => import("@spoctech/icons/To"),
"TopHiringsOutline": () => import("@spoctech/icons/TopHiringsOutline"),
"Tr": () => import("@spoctech/icons/Tr"),
"TrainedIcon": () => import("@spoctech/icons/TrainedIcon"),
"TranslateOutlined": () => import("@spoctech/icons/TranslateOutlined"),
"Tt": () => import("@spoctech/icons/Tt"),
"Tv": () => import("@spoctech/icons/Tv"),
"Tw": () => import("@spoctech/icons/Tw"),
"Tz": () => import("@spoctech/icons/Tz"),
"Ua": () => import("@spoctech/icons/Ua"),
"Ug": () => import("@spoctech/icons/Ug"),
"Um": () => import("@spoctech/icons/Um"),
"Un": () => import("@spoctech/icons/Un"),
"Us": () => import("@spoctech/icons/Us"),
"UserCheck": () => import("@spoctech/icons/UserCheck"),
"UserCheckOutline": () => import("@spoctech/icons/UserCheckOutline"),
"UserFilled": () => import("@spoctech/icons/UserFilled"),
"UserMinusOutline": () => import("@spoctech/icons/UserMinusOutline"),
"UserOutlined": () => import("@spoctech/icons/UserOutlined"),
"UserRoundCheckOutline": () => import("@spoctech/icons/UserRoundCheckOutline"),
"UsersOutline": () => import("@spoctech/icons/UsersOutline"),
"UsersRoundOutline": () => import("@spoctech/icons/UsersRoundOutline"),
"Uy": () => import("@spoctech/icons/Uy"),
"Uz": () => import("@spoctech/icons/Uz"),
"Va": () => import("@spoctech/icons/Va"),
"Vc": () => import("@spoctech/icons/Vc"),
"Ve": () => import("@spoctech/icons/Ve"),
"Vg": () => import("@spoctech/icons/Vg"),
"Vi": () => import("@spoctech/icons/Vi"),
"Visa": () => import("@spoctech/icons/Visa"),
"Vn": () => import("@spoctech/icons/Vn"),
"Vu": () => import("@spoctech/icons/Vu"),
"WalletIcon": () => import("@spoctech/icons/WalletIcon"),
"Wf": () => import("@spoctech/icons/Wf"),
"WhatsappIcon": () => import("@spoctech/icons/WhatsappIcon"),
"WindowIcon": () => import("@spoctech/icons/WindowIcon"),
"WindowOutlined": () => import("@spoctech/icons/WindowOutlined"),
"Ws": () => import("@spoctech/icons/Ws"),
"Xk": () => import("@spoctech/icons/Xk"),
"Xx": () => import("@spoctech/icons/Xx"),
"Ye": () => import("@spoctech/icons/Ye"),
"YoutubeIcon": () => import("@spoctech/icons/YoutubeIcon"),
"YoutubeOutlined": () => import("@spoctech/icons/YoutubeOutlined"),
"YoutubeSolid": () => import("@spoctech/icons/YoutubeSolid"),
"Yt": () => import("@spoctech/icons/Yt"),
"Za": () => import("@spoctech/icons/Za"),
"Zm": () => import("@spoctech/icons/Zm"),
"Zw": () => import("@spoctech/icons/Zw")
};